jQuery(document).ready(function ($) {
  function makeColumns() {
  $(':not(.ar-grid-2) + .ar-grid-2, * > .ar-grid-2:first-of-type').each(function () {
    $(this).nextUntil(':not(.ar-grid-2)').addBack().wrapAll('<div class="ar-grid" />');
  });
  $(':not(.ar-grid-3) + .ar-grid-3, * > .ar-grid-3:first-of-type').each(function () {
    $(this).nextUntil(':not(.ar-grid-3)').addBack().wrapAll('<div class="ar-grid" />');
  });
  $(':not(.ar-grid-4) + .ar-grid-4, * > .ar-grid-4:first-of-type').each(function () {
    $(this).nextUntil(':not(.ar-grid-4)').addBack().wrapAll('<div class="ar-grid" />');
  });
  $(':not(.ar-grid-5) + .ar-grid-5, * > .ar-grid-5:first-of-type').each(function () {
    $(this).nextUntil(':not(.ar-grid-5)').addBack().wrapAll('<div class="ar-grid" />');
  });
  $(':not(.ar-grid-6) + .ar-grid-6, * > .ar-grid-6:first-of-type').each(function () {
    $(this).nextUntil(':not(.ar-grid-6)').addBack().wrapAll('<div class="ar-grid" />');
  });
  }
  makeColumns();
});